import { axios } from '@Root/API'

export const edit = (studyProgrammeId, referencePeriodStudentLoadId, payload) => {
	return axios.post(`course-session/${studyProgrammeId}/reference-period-student-load/${referencePeriodStudentLoadId}`, payload)
}
